import { StoreSelector } from './StoreSelector';
import { useStore } from '../../hooks/useStore';

export function Header() {
  const { activeStore } = useStore();

  return (
    <header className="h-14 border-b border-[var(--ccb-border)] bg-white flex items-center justify-between px-6">
      <div className="flex items-center gap-3">
        <span className="text-sm text-[var(--ccb-text-secondary)]">Managing:</span>
        <StoreSelector />
      </div>

      <div className="flex items-center gap-4">
        <span className="text-xs text-[var(--ccb-text-secondary)] bg-slate-100 px-2.5 py-1 rounded-full">
          {activeStore.domain}
        </span>
      </div>
    </header>
  );
}
